import { z } from "zod";

export const NfSchema = z.object({
  partner: z.string().refine((value) => value.trim() !== "", {
    message: "Campo obrigatório",
  }),
  company: z.string().refine((value) => value.trim() !== "", {
    message: "Campo obrigatório",
  }),
  companyOrigin: z.string().refine((value) => value.trim() !== "", {
    message: "Campo obrigatório",
  }),
  serviceType: z.string().refine((value) => value.trim() !== "", {
    message: "Campo obrigatório",
  }),
  serviceValue: z.string().refine((value) => value.trim() !== "", {
    message: "Campo obrigatório",
  }),
  nf: z.any().refine((file) => file instanceof File && file.size > 0, {
    message: "Campo obrigatório",
  }),
});
